/* eslint-disable hubspot-dev/no-private-classes */
export const protectedDocs = {
  'Developers:AppObjectsDocs:PrivateBeta': {
    'en-us': {
      'guides/apps': ['app-objects/create-a-settings-component', 'app-objects/create-an-app-card', 'app-objects/migrate-an-existing-app-to-the-projects-framework', 'app-objects/overview', 'app-objects/quickstart-guide-to-app-objects', 'app-objects/reference', 'app-objects/set-up-demo-scheduling-from-the-app-listing-page', 'app-objects/view-contacts-created-from-the-marketplace'],
      'guides/developer-platform': ['features/app-objects/quickstart-guide-to-app-objects', 'features/app-objects/reference']
    }
  },
  'Developers:UnifiedApps:PrivateBetaDocs': {
    'en-us': {
      'guides/developer-platform': ['app-configuration', 'features/configure-webhooks', 'features/create-a-settings-component', 'features/create-an-app-card', 'features/custom-workflow-actions', 'features/set-up-demo-scheduling-from-the-app-listing-page', 'features/view-contacts-created-from-the-marketplace', 'migrate-an-existing-app-to-the-projects-framework', 'overview', 'quickstart-guide']
    }
  }
};